import {IAppliedFilter} from 'plugins/modules/filter/helpers/BrowserFilters/AppliedFilters';
import {IGroupItem} from 'plugins/modules/filter/helpers/GroupFacetFilters';
import {IFilterFacetGroup, IFilterFacetResponse, IFilterFacetTopFilter} from 'plugins/modules/filter/types';
import {createContext} from 'react';

export interface IFilterContext {
    appliedFilters: IAppliedFilter[];
    filterList: IFilterFacetGroup[];
    tabList?: IFilterFacetResponse['tabs'];
    groupedFiltersList: IGroupItem[];
    refetch?: () => void;
    isLoading?: boolean;
    isFiltersLocked?: boolean;
    topFilters?: IFilterFacetTopFilter[];
}

export const FilterContext = createContext<IFilterContext>({
    appliedFilters: [],
    filterList: [],
    tabList: [],
    groupedFiltersList: [],
    isLoading: false,
    isFiltersLocked: false,
    topFilters: [],
});
